import { useState, useEffect } from 'react';

interface Location {
  latitude: number;
  longitude: number;
  error?: string;
}

export function useGeolocation() {
  const [location, setLocation] = useState<Location | null>(null);
  const [loading, setLoading] = useState(false);

  const getLocation = async () => {
    if (loading) return; // Eğer zaten yükleniyorsa, yeni istek yapma
    
    if (!navigator.geolocation) {
      setLocation({ latitude: 0, longitude: 0, error: 'Tarayıcınız konum özelliğini desteklemiyor.' });
      return Promise.reject('Geolocation not supported');
    }

    setLoading(true);

    try {
      const position = await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        });
      });

      const newLocation = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      };

      setLocation(newLocation);
      setLoading(false);
      return newLocation;
      
    } catch (error) {
      let errorMessage = 'Konum alınamadı.';
      
      if (error instanceof GeolocationPositionError) {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'Konum izni reddedildi. Lütfen konum iznini etkinleştirin.';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Konum bilgisi alınamıyor.';
            break;
          case error.TIMEOUT:
            errorMessage = 'Konum alma isteği zaman aşımına uğradı.';
            break;
        }
      }
      
      setLocation({ latitude: 0, longitude: 0, error: errorMessage });
      setLoading(false);
      return Promise.reject(errorMessage);
    }
  };

  return { location, loading, getLocation };
}